import { UserGroup } from './user'

export interface AppActiveSubscriptions {
  id: string
  grootUid: string
  productId?: string
  paymentPlatform?: string
  originalTransactionId?: string
  startDate?: number
  endDate?: number
  createdAt?: Date
  updatedAt?: Date
}

export interface PaypalSubscriptions {
  id: number
  grootUid: string
  planCode?: string
  subscriptionId?: string
  startDate?: Date
  endDate?: Date
  insertedAt?: Date
  updatedAt?: Date
  lastSyncedAt?: Date
  syncError?: boolean
}

type CardElementState = {
  empty: boolean
  focus: boolean
  valid: boolean
}

export type CardElementChangeEvent = {
  brand: string
  cvv: CardElementState
  empty: boolean
  expiry: CardElementState
  firstSix: string
  focus: boolean
  lastFour: string
  number: CardElementState
  valid: boolean
}

export interface SubscriptionFormInput {
  first_name: string
  last_name: string
  address1: string
  city: string
  state: string
  country?: string
  postal_code: string
  cardDetails: CardElementChangeEvent
}

export interface SubscriptionInputFieldArgs {
  name: keyof SubscriptionFormInput
  label: string
  isRequired?: boolean
  disabled?: boolean
  type?: string
  errorMessage?: string
  maxLength?: number
}

export enum RecurlyPaymentMethodEnum {
  BRAINTREE_APPLE_PAY = 'braintree_apple_pay',
  CREDIT_CARD = 'credit_card',
  BRAINTREE_V_ZERO = 'braintree_v_zero',
}

export type RecurlyPaymentMethods = `${RecurlyPaymentMethodEnum}`

export enum UserType {
  INTERNAL = 'internal',
  LEGACY = 'legacy_paypal',
  APP = 'app_subscriber',
  CONSUMER = 'consumer',
}

export type UserTypes = `${UserType}`

export enum SubscriptionStatus {
  ACTIVE = 'active',
  EXPIRED = 'expired',
  CANCELLED = 'cancelled',
  FREE = 'free',
}

export type SubscriptionStatusType = `${SubscriptionStatus}`

export interface Invoice {
  id: string
  date: string
  amount: number
  planName: string
  couponName: string | null
}

export interface Billing {
  firstName: string
  lastName: string
  address: {
    line1: string
    line2: string | null
    city: string
    state: string
    zipCode: string
    country: string
  }
  cardType: string
  lastFour: string
  expMonth: number
  expYear: number
}

export interface SubscriptionOverviewInfo {
  profile: {
    email: string
    userGroup: UserGroup
    idmeId: string | null
  }
  userType: UserTypes
  subscriptionStatus: SubscriptionStatusType | null // Available only for UserType.CONSUMER
  paymentMethod: RecurlyPaymentMethods | null
  billing: Billing | null // null would be for free, paypal and apple users
  invoice: Invoice[]
  subscription: {
    planName: string | null // null would be for free users
    planCode: string | null // null would be for free users
    currentPeriodEndsAt: string | null
    expiresAt: string | null // for active and renewing subs, this will be null
  }
}

export const CARD_TYPES = {
  Visa: 'visa',
  MasterCard: 'mastercard',
  'American Express': 'amex',
  Discover: 'discover',
}

export interface AppSubscriptionUpdateInput {
  grootUid: string
  productId: string
  startDate: number
  endDate: number
  transactionId: string
  paymentPlatform: string
}

export const IDME_COUPONS = {
  military: 'e6d8976e-1ad2-46c4-bb01-7e4de1acbb90',
  student: '4fccf242-6be5-49d8-b6d6-5615a0bd453e',
  responder: '95v7x6yq-95g4-vfzp-y67f-ghwl7bsdp9a3',
}

export enum IdMeStatus {
  VERIFIED = 'verified',
  ERROR = 'error',
}

export enum IdMeError {
  UNAUTHORIZED = 'unauthorized',
  INVALID = 'invalid',
  DUPLICATE = 'duplicate',
}

export interface IdMeRedirectParams {
  redirectUrl: URL
  status: IdMeStatus
  error?: IdMeError
}
